import { z } from 'zod'

const stringToBoolean = z
  .union([z.string(), z.boolean()])
  .transform((val) => {
    if (typeof val === 'boolean') return val
    if (val.toLowerCase() === 'true') return true
    if (val.toLowerCase() === 'false') return false
    throw new Error(`Invalid boolean value: ${val}`)
  })

const envSchema = z.object({
  MODE: z.enum(['development', 'production']).default('development'),
  VITE_API_URL: z.string().url(),
  VITE_ROLLBAR_ENABLED: stringToBoolean.default(false),
  VITE_API_URL_LOCKED: stringToBoolean.default(false),
	VITE_ROLLBAR_ACCESS_TOKEN: z.string().optional(),
  VITE_CATALOGO_API_URL: z.string().url().default('https://api-catalogo.cnesistemasfv.com.br')
})


export const env = envSchema.parse(import.meta.env)